export default {
  en: {
    clearButtonAccessibilityLabel: 'Clear',
    showPasswordAccessibilityLabel: 'Show Password',
    hidePasswordAccessibilityLabel: 'Hide Password'
  },
  fr: {
    clearButtonAccessibilityLabel: 'Effacer',
    showPasswordAccessibilityLabel: 'montrer le mot de passe',
    hidePasswordAccessibilityLabel: 'masquer le mot de passe'
  }
};